// const webApiUrl = "https://localhost:44375/api"; // testing

import { webApiUrl } from "./constants";

export interface KenectIntegration {
  id: number;
  organizationId: number;
  partnerLocationId: string;
  locationName: string;
  address: string;
  address2: string | null;
  city: string;
  state: string;
  zip: string;
  phone: string;
}

export const getKenectLocations = async (
  token: string
): Promise<KenectIntegration[]> => {
  const request = new Request(
    `${webApiUrl}/GetKenectCustomersEndpoint/kenect/locations`,
    {
      method: "get",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );

  let response = await fetch(request);

  if (response.ok) {
    const locations: KenectIntegration[] = await response.json();
    return locations;
  }

  return [];
};
